import { useState } from "react";
import { API } from "../lib/api";

export const GOLD_RING = "conic-gradient(from 210deg, #8a6a1f, #f6e3a1, #c9a23f, #fff3c4, #a67c1e, #e9c96b, #8a6a1f)";

// Pastille ronde à anneau doré : photo de l'auteur (utilisateur ou agent), emblème pour XALTIX, sinon initiale.
export const MsgAvatar = ({ author, name, base = "/messages", size = 32, testid }) => {
  const [broken, setBroken] = useState(false);
  const system = author === "system";
  const src = system ? "/xaltix-emblem.png" : `${API}${base}/avatar/${encodeURIComponent(author || "")}`;
  return (
    <div data-testid={testid} className="rounded-full shrink-0 self-end" title={name}
      style={{ width: size, height: size, padding: Math.max(2, size / 16), background: GOLD_RING, boxShadow: "0 1px 4px rgba(120,90,20,.35)" }}>
      {!broken && author ? (
        <img src={src} alt={name || ""} onError={() => setBroken(true)} className={`h-full w-full rounded-full ${system ? "object-contain bg-[#0B2A7A] p-[2px]" : "object-cover"}`} />
      ) : (
        <div className="h-full w-full rounded-full grid place-items-center text-white font-bold" style={{ backgroundColor: "#0B2A7A", fontSize: size * 0.38 }}>
          {(name || "?").trim()[0]?.toUpperCase()}
        </div>
      )}
    </div>
  );
};
